import { createRoot } from 'react-dom/client';

import 'object-assign-polyfill';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'url-search-params-polyfill';
import './compiled_index.css';

import * as Sentry from '@sentry/react';

import packageJson from '../package.json';
import App from './App';
import { COLLECTOR_URL } from './telemetry/config';

if (process.env.REACT_APP_SENTRY_INIT) {
  Sentry.init({
    dsn: 'https://8cc70055f9754abe9f8ac7d227275326@o161285.ingest.sentry.io/5711496',
    release: packageJson.version,
  });
}

// No collector configured means no telemetry at all, not even the instrumentation. This is
// the deploy-level switch, and production ships with it off.
//
// Loaded dynamically so the SDK lands in a chunk of its own: a deployment with telemetry off
// never requests it, instead of downloading and parsing it on every single visit. `config` is
// imported statically because it holds the switch itself and pulls in nothing.
//
// Resolving after the `load` event costs no document-load trace:
// `DocumentLoadInstrumentation` checks `document.readyState` and, when the page has already
// finished, rebuilds the span from the Performance API instead of waiting for an event that
// has been and gone.
if (COLLECTOR_URL) {
  void import('./telemetry').then(({ initTelemetry }) => initTelemetry(packageJson.version));
}
// eslint-disable-next-line
console.log('%cDatascope', 'color: #3E8FFA; font-size: 35px; background-color: #FAFBFF;');
console.log(
  '%cVersion: ' + packageJson.version,
  'color: #3E8FFA; font-size: 20px; background-color: #FAFBFF;',
);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
